import { useFormContext } from "react-hook-form";
import ErrorMessage from "./ErrorMessage";

/**
 * List out the forms active error messages
 */
const ErrorMessages = () => {
  const {
    formState: { errors },
    clearErrors
  } = useFormContext();

  const messages = Object.values(errors);

  return (
    <>
      {messages.length > 0 && (
        <div className="mb-4 flex w-full flex-col gap-2">
          {/* Group required field errors into one message */}
          {messages.filter(m => m?.type === "required").length > 0 && (
            <ErrorMessage
              message="Please fill in the required fields marked *"
              clearError={clearErrors}
            />
          )}

          {/* Otherwise also list all other error types */}
          {messages
            .filter(m => m?.type !== "required")
            .map(
              (message, index) =>
                message?.message && (
                  <ErrorMessage
                    key={index}
                    message={message?.message.toString()}
                    clearError={clearErrors}
                  />
                )
            )}
        </div>
      )}
    </>
  );
};

export default ErrorMessages;
